import { Suspense, lazy } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { theme } from '@globalwebindex/platform2-react-ui-components/src/ui/theme';
import { ChatProvider } from '@/context/chatContext';
import { BrowserRouter as Router } from 'react-router-dom';
import * as Sentry from '@sentry/react';

export const muiCache = createCache({
  key: 'messengermuicache',
  prepend: true
});

function App() {
  const AppInner = lazy(() => import('./messages/Messages'));

  return (
    <Sentry.ErrorBoundary
      fallback={
        <div className="flex flex-col gap-5 justify-center items-center h-screen font-faktum font-semibold ">
          <div className="h1 text-lg">It seems that an error has cause the application to crash.</div>
          <div className="h2 text-sm">Please contact the Polaris team for more details.</div>
        </div>
      }
    >
      <Suspense fallback={<div>Loading...</div>}>
        <CacheProvider value={muiCache}>
          <ThemeProvider theme={theme}>
            <Router>
              <ChatProvider>
                <AppInner />
              </ChatProvider>
            </Router>
          </ThemeProvider>
        </CacheProvider>
      </Suspense>
    </Sentry.ErrorBoundary>
  );
}

export default App;
